// Query Comparison API client (admin). Runs two statements A/B on one
// connection and returns timing, EXPLAIN, Handler deltas, and equivalence.
import { api } from './api.js';

// → { ok, database, runs,
//     a: { ms:[…], min, median, avg, rows, explain:{columns,rows}, handler:{…}, error? },
//     b: { … },
//     equivalence: { checked, equal?, rowsA, rowsB, snapshot?, note? } }
// connectionId comes from a <select> (a string); the Go handler wants int64.
export const runQueryCompare = (connectionId, database, sqlA, sqlB, runs) =>
  api.post('/api/tools/query-compare', { connectionId: Number(connectionId), database: database || '', sqlA, sqlB, runs });
